export const REGISTER_START = 'REGISTER_START'
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS'
export const REGISTER_FAILURE = 'REGISTER_FAILURE'
export const LOGIN_START = 'LOGIN_START'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'
export const LOGOUT_START = 'LOGOUT_START'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'

export const AUTHENTICATE = 'AUTHENTICATE'
export const DEAUTHENTICATE = 'DEAUTHENTICATE'

export const SET_USER = 'SET_USER'
export const RESET_USER = 'RESET_USER'
export const UPDATE_USER_START = 'UPDATE_USER_START'
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS'
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE'

export const GET_ALL_ANIME_START = 'GET_ALL_ANIME_START'
export const GET_ALL_ANIME_SUCCESS = 'GET_ALL_ANIME_SUCCESS'
export const GET_ALL_ANIME_FAILURE = 'GET_ALL_ANIME_FAILURE'

export const GET_ANIME_DETAIL_START = 'GET_ANIME_DETAIL_START'
export const GET_ANIME_DETAIL_SUCCESS = 'GET_ANIME_DETAIL_SUCCESS'
export const GET_ANIME_DETAIL_FAILURE = 'GET_ANIME_DETAIL_FAILURE'

export const UPDATE_ANIME_DETAIL_START = 'UPDATE_ANIME_DETAIL_START'
export const UPDATE_ANIME_DETAIL_SUCCESS = 'UPDATE_ANIME_DETAIL_SUCCESS'
export const UPDATE_ANIME_DETAIL_FAILURE = 'UPDATE_ANIME_DETAIL_FAILURE'

export const GET_ALL_MANGA_START = 'GET_ALL_MANGA_START'
export const GET_ALL_MANGA_SUCCESS = 'GET_ALL_MANGA_SUCCESS'
export const GET_ALL_MANGA_FAILURE = 'GET_ALL_MANGA_FAILURE'

export const GET_MANGA_DETAIL_START = 'GET_MANGA_DETAIL_START'
export const GET_MANGA_DETAIL_SUCCESS = 'GET_MANGA_DETAIL_SUCCESS'
export const GET_MANGA_DETAIL_FAILURE = 'GET_MANGA_DETAIL_FAILURE'

export const UPDATE_MANGA_DETAIL_START = 'UPDATE_MANGA_DETAIL_START'
export const UPDATE_MANGA_DETAIL_SUCCESS = 'UPDATE_MANGA_DETAIL_SUCCESS'
export const UPDATE_MANGA_DETAIL_FAILURE = 'UPDATE_MANGA_DETAIL_FAILURE'

export const SEARCH_ITEM_START = 'SEARCH_ITEM_START'
export const SEARCH_ITEM_SUCCESS = 'SEARCH_ITEM_SUCCESS'
export const SEARCH_ITEM_FAILURE = 'SEARCH_ITEM_FAILURE'
export const SEARCH_ITEM_RESET = 'SEARCH_ITEM_RESET'
export const SET_ITEM_TYPE = 'SET_ITEM_TYPE'
